import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AddSubordinateAccount = () => {
  const [accountType, setAccountType] = useState("");
  const storedUid = localStorage.getItem("uid"); // Get role from localStorage
  const panelRole = localStorage.getItem("role"); // Get role from localStorage
  const [selectedType, setSelectedType] = useState("Bonus");

  // Hierarchy of valid roles for each user role
  const validHierarchy = {
    admin: ["agent", "operator", "shops", "manager", "cashier", "user"],
    agent: ["operator", "shops", "manager", "cashier", "user"],
    operator: ["shops", "manager", "cashier", "user"],
    shops: ["manager", "cashier", "user"],
    manager: ["cashier", "user"],
    cashier: ["user"], // Cashiers can only create users
  };

  // Role display names mapping
  const roleDisplayNames = {
    admin: "Admin panel",
    agent: "Sub-admin panel",
    operator: "Super agent panel",
    shops: "Master Agent panel",
    manager: "Agent panel",
    cashier: "Cashier panel",
    user: "User Panel"
  };

  // Function to get available roles based on the current user's role
  const getAvailableRoles = (role) => {
    return validHierarchy[role] || []; // Get roles allowed for this role
  };

  const [formData, setFormData] = useState({
    fullName: "",
    userName: "",
    email: "",
    password: "",
    retypePassword: "",
    phone: "",
    address: "",
    credit: 0,
  });
  const [error, setError] = useState(""); // To handle the error message

  // Handle account type change
  const handleAccountTypeChange = (e) => {
    setAccountType(e.target.value);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission (Create User or Create Subordinate)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    // Check if password and retypePassword match
    if (formData.password !== formData.retypePassword) {
      setError("Passwords do not match");
      return; // Prevent form submission if passwords don't match
    } else {
      setError(""); // Clear error if passwords match
    }

    // Create a copy of formData
    let payload = { ...formData };
    delete payload.retypePassword;

    // If accountType is "user", remove unnecessary fields
    if (accountType === "user") {
      delete payload.fullName;
      delete payload.phone;
      delete payload.address;
      payload.type = "B2B";
    }

    // Add parent_id to payload
    payload.parent_id = storedUid;
    payload.role = accountType;
    payload.creditType = selectedType;

    // Define the correct API endpoint based on the accountType
    const endpoint =
      accountType === "user"
        ? `${process.env.REACT_APP_BASE_URL_API}/admin/createUser`
        : `${process.env.REACT_APP_BASE_URL_API}/admin/createSubordinate`;

    // Send the POST request with the modified payload
    try {
      const response = await axios.post(endpoint, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("API Response: ", response.data);

      // Show success toast notification
      toast.success(
        `${accountType.charAt(0).toUpperCase() + accountType.slice(1)} account created successfully!`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      // Reset form after successful creation
      setFormData({
        fullName: "",
        userName: "",
        email: "",
        password: "",
        retypePassword: "",
        phone: "",
        address: "",
        credit: 0,
      });
      setAccountType("");

    } catch (error) {
      console.error("Error creating account: ", error);

      // Show error toast notification
      const errorMessage = error.response?.data?.message || "Failed to create account. Please try again.";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className="ml-0 lg:ml-[256px] p-1 ">
      <div className="bg-[#ffffff] text-black p-6 rounded-xl shadow-lg w-full max-w-4xl">
        <h2 className="text-3xl font-semibold mb-4 text-center">Add Account</h2>
        {/* Account Detail */}
        <div className="p-4 rounded-lg ">
          <h4 className="text-lg font-semibold mb-6 border-b pb-2">
            Account Detail
          </h4>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="whiteblock mb-1 text-black">Account Type:</label>
              <select
                className="w-full p-2 rounded bg-[#ffffff] text-black border border-gray-6000"
                value={accountType}
                onChange={handleAccountTypeChange}
              >
                <option value="">- Select Your Account Type -</option>
                {/* Dynamically render available roles based on panelRole */}
                {getAvailableRoles(panelRole).map((role) => (
                  <option key={role} value={role}>
                    {roleDisplayNames[role] || role.charAt(0).toUpperCase() + role.slice(1)}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="whiteblock mb-1 text-black">Credit:</label>
              <input
                type="number"
                min="0"
                name="credit"
                value={formData.credit}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="Credit Amount"
              />
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="whiteblock mb-1 text-black">
                  Account Type:
                </label>
                <select
                  className="w-full p-2 rounded bg-[#ffffff] text-black border border-gray-600"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="Bonus">Bonus</option>
                  <option value="received_payment">As A Payment</option>
                </select>
              </div>
            </div>

            {/* <div>
              <label className="whiteblock mb-1 text-black">Given Percentage:</label>
              <input
                type="number"
                min="0"
                max="100"
                name="givenPercentage"
                value={formData.credit}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="Credit Amount"
              />
            </div> */}
          </div>
        </div>

        {/* Personal Detail */}
        <div className="p-4 rounded-lg mt-6">
          <h4 className="text-lg font-semibold mb-6 border-b pb-2">
            Personal Detail
          </h4>
          <div className="grid grid-cols-2 gap-4">
            {/* Conditionally render Full Name if accountType is not 'user' */}
            {accountType !== "user" && (
              <div>
                <label className="whiteblock mb-1 text-black">Full Name:</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                  placeholder="Full Name"
                />
              </div>
            )}

            {/* UserName is always displayed */}
            <div>
              <label className="whiteblock mb-1 text-black">UserName:</label>
              <input
                type="text"
                name="userName"
                value={formData.userName}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="UserName"
              />
            </div>

            {/* Email input */}
            <div>
              <label className="whiteblock mb-1 text-black">Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="Email"
              />
            </div>

            {/* Password and Retype Password inputs */}
            <div>
              <label className="whiteblock mb-1 text-black">Password:</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="Password"
              />
            </div>
            <div>
              <label className="whiteblock mb-1 text-black">
                Retype Password:
              </label>
              <input
                type="password"
                name="retypePassword"
                value={formData.retypePassword}
                onChange={handleInputChange}
                className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                placeholder="Retype Password"
              />
            </div>

            {/* Conditionally render Phone and Address if accountType is not 'user' */}
            {accountType !== "user" && (
              <>
                <div>
                  <label className="whiteblock mb-1 text-black">Phone:</label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                    placeholder="Phone"
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>

                <div>
                  <label className="whiteblock mb-1 text-black">Address:</label>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className="w-full p-2 rounded bg-transparent text-black border border-gray-600"
                    placeholder="Address"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Display error message if passwords don't match */}
        {error && <p className="text-red-500 text-center mt-2">{error}</p>}

        <div className="mt-6 text-right">
          <button
            onClick={handleSubmit}
            className="bg-[#228BE6] hover:bg-[#000000] text-white py-2 px-4 rounded-lg"
          >
            Create <span>{accountType ? (roleDisplayNames[accountType] || accountType) : "user"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSubordinateAccount;
